import { Exclude, Type } from 'class-transformer';
import {
  IsBoolean,
  IsDate,
  IsInt,
  IsOptional,
  IsString,
  Length,
} from 'class-validator';

export class NpsSurveyUpdateDto {
  @Exclude()
  id: number;

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  pieMerchantGroupId: number;

  @IsOptional()
  @IsString()
  @Length(1, 45)
  name: string;

  @IsOptional()
  @IsString()
  @Length(1, 255)
  description: string;

  @IsOptional()
  @IsDate()
  @Type(() => Date)
  startDate: Date;

  @IsOptional()
  @IsDate()
  @Type(() => Date)
  endDate: Date;

  @IsOptional()
  @IsBoolean()
  isActive: boolean;

  @Exclude()
  isOnline?: boolean;

  @IsOptional()
  @IsBoolean()
  isPublished: boolean;

  @Exclude()
  createdDate: Date;

  @Exclude()
  modifiedDate: Date;
}
